import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
const checkPassword = () => { // 숫자 영문 만 가능하게 변경
    return helpers.regex('alphaNum', /^[A-Za-z0-9]*$/)
};

const checkString = () => { // 한글 + 부호는 - 만 입력가능
    return helpers.regex('alpha', /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ\-]*$/)
};

const checkNumber = () => { // 숫자만 입력 가능
    return helpers.regex('alpha', /^[0-9]*$/);
};

Vue.use(SimpleVueValidation);
export default {
    data() {
        return{
            type: '',
            id: '',
            no: '',
            password: '',
            password_chk: '',
            name : '',
            nick: '',
            memo: '',

        }
    },
    validators: {
        id: function (value) {
            return Validator.value(value)
                .required('아이디를 입력해주세요.')
                .email('올바른 이메일 형식이 아닙니다.')
        },
        password: function (value) {
            return Validator.value(value)
                .required('비밀번호를 입력해주세요.')
                .minLength(8, '영문 대/소문자 포함 8자 이상 16자 이내로 작성해주세요.')
                .maxLength(16, '영문 대/소문자 포함 8자 이상 16자 이내로 작성해주세요.')
                .regex('^.*(?=.*[0-9])(?=.*[a-zA-Z]).*$', '영문 대/소문자 포함 8자 이상 16자 이내로 작성해주세요.')
        },
        password_chk: function (value) {
            return Validator.value(value)
                .custom(
                    () => {
                        if(value != this.password) {
                            return '비밀번호가 일치하지 않습니다.'
                        }
                    }
                )
        },
        name: function (value) {
            return Validator.value(value)
        },
        nick: function(value) {
            return Validator.value(value)
                .required('닉네임을 입력해주세요.')
                .maxLength(20, '닉네임은 20자 이내만 가능합니다.')
                .regex('^[A-Za-z0-9]*$', '닉네임은 영문만 가능합니다.')
        },
        memo: function (value) {
            return Validator.value(value)
        },
        type: function (value) {
            return Validator.value(value)
        },
        no: function (value) {
            return Validator.value(value)
        }
    },
    methods:{
    }
}
